import { useEffect } from "react";

const SUFFIX = " · GoSmartNest";

export default function usePageTitle(title) {
    useEffect(() => {
        const prev = document.title;
        document.title = title.endsWith("GoSmartNest") ? title : `${title}${SUFFIX}`;
        return () => { document.title = prev; };
    }, [title]);
}
